import React, { useEffect, useState } from "react";
import '../BillingModule.css';
import {
  getAuthSession,
  GET_CUSTOMER_DETAIS,
  getPreUrlAccordingToCart,
  InternalBillType,
  isEmpty,
  SUCCESS
} from "../../../constants/constant";
import { snpAxios } from "../../global/api";
import { INITIAL_CUSTOMER_DATA, INITIAL_POINT_DETAILS } from "../resto-billing/RestBillConstants";
import { CircularProgress, FormControl, FormHelperText, Paper, TextField, Typography } from "../../ui";
import SnpButton from "../../global/SnpButton";
import { useRef } from "react";
import uiUtilInstance from "../../../utilities/uiUtil";

const RenderCustomerHotelForm = ({
    isPaid,
    storeApiUrl,
    customerData,
    custAvailable,
    setCustAvailable,
    storeActiveShopHash,
    setCustomerData,
    setLoyalityPointDetails,
    setCustDialog,
    hotelSale,
    billType,
    externalBillDetails,
    setHotelRoomDialog
}) => {

    const [isCustLoading, setIsCustLoading] = useState(false);
    const mobileRef = useRef(null);

    const getCustomerData = async (e) => {
        try {
            if (e.target.value.length === 10) {
                const custgUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + GET_CUSTOMER_DETAIS;
                const data = {
                    jcJson: {
                        apiToken: getAuthSession().apiToken,
                        shopHash: storeActiveShopHash.id,
                        custMob: e.target.value
                    }
                };
                setIsCustLoading(true);
                const response = await snpAxios.post(custgUrl, data);
                if (response.data.status === SUCCESS) {
                    const jcJson = response.data.jcJson;
                    setCustomerData(prev => ({
                        ...prev, ...jcJson,
                    }));
                    setCustAvailable(!isEmpty(jcJson.custName));
                    setLoyalityPointDetails(prev => ({
                        ...prev,
                        pointRedeem: Number(jcJson.royalityPoint),
                        redeemRoyaltyPrice: Number(jcJson.royalityPoint) > 0,
                    }))
                } else {
                    setCustAvailable(false);
                    setCustomerData(prev=> ({
                        ...prev,...INITIAL_CUSTOMER_DATA,
                        custMob:e.target.value,
                    }));
                    setLoyalityPointDetails(INITIAL_POINT_DETAILS);
                }
                setIsCustLoading(false);
                e.target.value = "";
            }
        } catch (error) {
            console.error(`getCustomerData:${e.target.value}`, error);
            setIsCustLoading(false);
        }
    };
    const hotelDetails = () => {
        return (
            <div className="billing-data-container">
                <Typography
                    variant="p" component="div"
                    className="existing-customer-search" style={{ marginBottom: "10px" }}>{uiUtilInstance.showHotKeySpanWithText("ctrl+alt+h","Hotel Details","11px")}</Typography>
                <SnpButton
                    size="small"
                    variant="contained" color="primary" onClick={() => setHotelRoomDialog(true)}>
                    {isEmpty(externalBillDetails.hotelBillNo) ? "Search Room" : "Room No : " + externalBillDetails.hotelBillNo}
                </SnpButton>
            </div>
        )
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            //printDebugLog("handleKeyDown",event);
            if (event.ctrlKey && event.key === '3') {
                event.preventDefault();
                mobileRef.current?.focus();
            } else if (event.ctrlKey && event.altKey && event.key === 'h') {
                event.preventDefault();
                setHotelRoomDialog(true);
            } else if (event.ctrlKey && event.key === '4') {
                event.preventDefault();
                setCustDialog(true);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <Paper elevation={0}
            sx={{
                display: "flex",
                flexDirection: "row",
                backgroundColor: "#cec0c0",
                boxShadow: 1,
                borderRadius: 5,
                padding: 1,
            }}>

            <div className="billing-data-grid-container">
                {(hotelSale && billType !== InternalBillType.Home)
                    && hotelDetails()}
                {

                    (!isPaid) && <div className="billing-data-container">

                        <Typography
                            variant="p" component="div"
                            className="existing-customer-search" style={{ marginBottom: "10px" }}>{uiUtilInstance.showHotKeySpanWithText("ctrl+3","Search for Customer :","11px")}</Typography>
                        <TextField id="outlined-basic" label="Mobile Number"
                            variant="filled" size="small"
                            inputRef={mobileRef}
                            className="existing-customer__mobile-number"
                            style={{ marginBottom: "15px" }} onChange={getCustomerData} disabled={isCustLoading ? true : false} />
                        <span style={{ verticalAlign: "middle" }}>
                            {isCustLoading ? <CircularProgress color="primary" size={30} /> : ''}
                        </span>

                    </div>
                }
                {!isEmpty(customerData.custMob) &&
                    <div className="billing-data-container">
                        {
                            !custAvailable && <Typography variant="p" component="div" className="existing-customer__error" style={{ whiteSpace: "initial" }}>
                                Customer Not Found!! Please make a new entry.</Typography>
                        }

                        {custAvailable &&
                            <div className="customer-details-container">
                                <Typography variant="p" component="div"
                                    className="customer-details" >Bill To : </Typography>
                                <Typography variant="p" component="div"
                                    className="customer-name" >{customerData.custName} </Typography>
                                <Typography variant="p" component="div"
                                    className="customer-details customer-mob-num" >{customerData.custMob} </Typography>
                                <Typography variant="p" component="div"
                                    className="customer-details customer-email-id"
                                    style={{ whiteSpace: "initial", wordBreak: 'break-word' }}>{customerData.custEmail}</Typography>
                            </div>
                        }
                    </div>
                }
                <div>
                    {!isPaid && !isEmpty(customerData.custMob) && (
                        <FormControl>
                            <SnpButton
                                variant="contained"
                                className="new-customer-entry"
                                aria-describedby="new-customer-button-helper-text"
                                style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                onPointerDown={() => setCustDialog(true)}
                            >
                                {isEmpty(customerData.custId) ? "Add New Customer" : "Update Customer"}
                            </SnpButton>
                            <FormHelperText sx={{ textAlign: 'center' }} id="new-customer-button-helper-text">
                                {uiUtilInstance.showHotKeySpan("ctrl+4")}
                            </FormHelperText>
                        </FormControl>
                    )}

                </div>
            </div>
        </Paper>
    )
};
export default React.memo(RenderCustomerHotelForm);